module.exports = __webpack_public_path__ + "img/table.0e8cc992.webp";